import type { OrgType, Role } from '@ready/shared';

export const ORG_TYPE_LABELS: Record<OrgType, string> = {
  nirvik: 'Nirvik',
  university: 'University',
  enterprise: 'Enterprise',
  school: 'School',
  government: 'Government',
  nonprofit: 'Nonprofit',
  community: 'Community',
};

export const ROLE_LABELS: Record<Role, string> = {
  learner: 'Learner',
  judge: 'Judge',
  facilitator: 'Facilitator',
  author: 'Author',
  admin: 'Admin',
  owner: 'Owner',
};

export const JOIN_POLICY_LABELS = {
  open: 'Open — verified-domain emails join automatically',
  approval: 'Approval — verified-domain emails request to join',
  invite_only: 'Invite only — domain just suggests this org',
  managed: 'Managed — the org controls accounts (needs SSO)',
} as const;
